import collectionCardFooterStyles from './CollectionCardFooter/CollectionCardFooter.scss';
export { default } from './CollectionCard';
export const FOOTER_HEIGHT = parseInt(collectionCardFooterStyles['footer-height']);
